/**
 * Created by staffanrantzow on 06/04/16.
 */

import moment from 'moment';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';

class Utils {

  static truncateName (name, maxLength) {
    var max, nameLength;

    max = maxLength || 8;
    nameLength = name.length;

    if (nameLength > max) {
      return name.substring(0, max) + '...';
    } else {
      return name;
    }
  }

  static formatDate (date) {
    var m = moment(date);

    if (m.isValid()) {
      return m.format('YYYY-MM-DD');
    } else {
      return '-';
    }
  }

  static amountWithCurrency (amount, currencyId) {
    switch (currencyId) {
      case 1:
        return amount + ' ' + proxyCounterpart('SEK');
      case 2:
        return amount + ' ' + proxyCounterpart('EURO_SHORT');
      case 3:
        return proxyCounterpart('DOLLAR_SHORT') + ' ' + amount;
      default:
        return amount + ' ' + proxyCounterpart('SEK');
    }
  }

  /**
   * Convert API data into object with value and valid status
   * for InputField-component
   *
   * @param data
   * @returns {{}}
   */
  static getInputValueObjects (data) {
    var inputValues = {};

    for (let i in data) {
      if (typeof data[i] === 'object' && data[i] !== null) {
        for (let j in data[i]) {
          inputValues[j] = {
            value: data[i][j],
            valid: true
          };
        }
      } else {
        inputValues[i] = {
          value: data[i],
          valid: true
        };
      }
    }

    return inputValues;
  }

  static getPostParams (inputValues) {
    var params = {};

    for (let i in inputValues) {
      params[i] = inputValues[i].value;
    }

    return params;
  }

  static validateInputValues (inputValues) {
    for (let i in inputValues) {
      if (!inputValues[i].valid) {
        return false;
      }
    }

    return true;
  }

  static isInt (value) {
    var x;
    if (isNaN(value)) {
      return false;
    }
    x = parseFloat(value);
    return (x | 0) === x;
  }

  static isNumeric (n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  static getLineBreaks (text) {
    if (text === null) {
      return '';
    }

    return text.replace(/(?:\r\n|\r|\n)/g, '<br/>');
  }

  // Copied from http://locutus.io/php/xml/utf8_decode/
  static utf8Decode (strData) {
    var tmpArr = [];
    var i = 0;
    var c1 = 0;
    var seqlen = 0;

    strData += '';

    while (i < strData.length) {
      c1 = strData.charCodeAt(i) & 0xFF;
      seqlen = 0;

      // http://en.wikipedia.org/wiki/UTF-8#Codepage_layout
      if (c1 <= 0xBF) {
        c1 = (c1 & 0x7F);
        seqlen = 1;
      } else if (c1 <= 0xDF) {
        c1 = (c1 & 0x1F);
        seqlen = 2;
      } else if (c1 <= 0xEF) {
        c1 = (c1 & 0x0F);
        seqlen = 3;
      } else {
        c1 = (c1 & 0x07);
        seqlen = 4;
      }

      for (var ai = 1; ai < seqlen; ++ai) {
        c1 = ((c1 << 0x06) | (strData.charCodeAt(ai + i) & 0x3F));
      }

      if (seqlen === 4) {
        c1 -= 0x10000;
        tmpArr.push(String.fromCharCode(0xD800 | ((c1 >> 10) & 0x3FF)));
        tmpArr.push(String.fromCharCode(0xDC00 | (c1 & 0x3FF)));
      } else {
        tmpArr.push(String.fromCharCode(c1));
      }

      i += seqlen;
    }

    return tmpArr.join('');
  }

  static normalizeVatNumber = (vatNumber) => {
    return vatNumber.replace(/[^0-9]/, '');
  }

  static isValidChecksum (vatNumber) {
    if (/[^0-9-\s]+/.test(vatNumber)) return false;

    var nCheck = 0;
    var nDigit = 0;
    var cDigit = 0;
    var bEven = false;
    vatNumber = vatNumber.replace(/\D/g, '');

    for (var n = vatNumber.length - 1; n >= 0; n--) {
      cDigit = vatNumber.charAt(n);
      nDigit = parseInt(cDigit, 10);

      if (bEven) {
        if ((nDigit *= 2) > 9) nDigit -= 9;
      }

      nCheck += nDigit;
      bEven = !bEven;
    }

    return (nCheck % 10) === 0;
  }

  static isVatNumber = (vatNumber) => {
    vatNumber = vatNumber.replace(/[^0-9]/, '');

    if (vatNumber.length === 10) {
      let month = vatNumber.substring(2, 4);
      return Utils.isValidChecksum(vatNumber) && month >= 20;
    }
    return false;
  }

  static containsAtSign = (value) => {
    if (value) return value.includes('@');

    return false;
  }

  static isValidEinvoiceAddress = (value) => {
    if (!value) {
      return false;
    }

    const characters = value.replace(/ /g, '').length;
    return characters >= 10 && characters <= 50 && !Utils.containsAtSign(value);
  };

  static numberToOneDecimal (value) {
    return Math.round((value) * 10) / 10;
  }

  static floor (value) {
    return Math.floor(value);
  }

  static numberWithSpaces (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }
}

export default Utils;



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/utils/utils.js
 **/